var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryIconCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 300 300",
    viewBox: "0 0 300 300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D6EDF;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m265.54 249.02h-231.31c-18.89 0-34.26-15.37-34.26-34.26v-129.52c0-18.89 15.37-34.26 34.26-34.26h231.3c18.89 0 34.26 15.37 34.26 34.26v129.52c0.01 18.89-15.36 34.26-34.25 34.26zm-231.31-178.9c-8.34 0-15.12 6.78-15.12 15.12v129.52c0 8.34 6.78 15.12 15.12 15.12h231.3c8.34 0 15.12-6.78 15.12-15.12v-129.52c0-8.34-6.78-15.12-15.12-15.12h-231.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 9.54,
    y: 104.12,
    width: 280.68,
    height: 19.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m126.92 174.93h-74.94c-5.29 0-9.57-4.29-9.57-9.57s4.29-9.57 9.57-9.57h74.94c5.29 0 9.57 4.29 9.57 9.57s-4.28 9.57-9.57 9.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m88.96 204.45h-36.98c-5.29 0-9.57-4.29-9.57-9.57s4.29-9.57 9.57-9.57h36.98c5.29 0 9.57 4.29 9.57 9.57s-4.29 9.57-9.57 9.57z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIconCreditCard);
export default __webpack_public_path__ + "static/media/summary_icon_credit_card.b6eb51bb886123785e56d1ad0651ede5.svg";
export { ForwardRef as ReactComponent };